<template>
  <div class="noDataBox">
    <svg-icon icon-class="noData" :style="{fontSize:size}"></svg-icon>
    <h3>{{title}}<slot name="link"></slot></h3>
  </div>
</template>
<script>
export default {
  name: 'NoData',
  props: {
    size: {
      type: String,
      default: '100px'
    },
    title: {
      type: String,
      default: '暂无数据'
    }
  }
};
</script>

<style scoped>
.noDataBox {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}
h3 {
    font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/NoData/index.vue